import { ClassName } from '@type/component-data-types'
import * as React from 'react'

type Props = {
  type?: 'main' | 'children'
  children?: React.ReactNode
  className?: ClassName
}

const Article = React.memo((props: Props): React.JSX.Element => {
  let cssClass: ClassName = ''
  if (props.type === 'main') {
    cssClass = 'mb-7'
  } else if (props.type === 'children') {
    cssClass = 'mb-5'
  }
  cssClass = props.className ? `${cssClass} ${props.className}` : cssClass

  return <article className={cssClass}>{props.children}</article>
})
export default Article
